import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import HomePage from '../pages/Home/Homepage';
import ProtectedRoute from './ProtectedRoute';
import Login from '../pages/Login/Login';
import { useAuth } from 'src/hooks/useAuth';
import JoinApp from 'src/pages/JoinApp/JoinApp';
import HomePageNMSDash from '../pages/Home/HomepageNMS';

const AppRoutes = ({
  toggleTheme,
  themeMode,
}: {
  toggleTheme: () => void;
  themeMode: 'light' | 'dark';
}) => {
  const { isAuthenticated, user } = useAuth();
  let lastVisitedPath = localStorage.getItem('lastVisitedPath');
  if (
    !lastVisitedPath ||
    lastVisitedPath == undefined ||
    lastVisitedPath == null
  ) {
    if (user && user.dash && user.dash.activeType === 'NMS') {
      lastVisitedPath = '/home/NMS-Alert-Zendesk';
    } else {
      lastVisitedPath = '/home/transactions';
    }
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/join-app/:activationCode" element={<JoinApp />} />
        <Route element={<ProtectedRoute />}>
          <Route
            path="/home/*"
            element={
              <HomePage themeMode={themeMode} toggleTheme={toggleTheme} />
            }
          />
          {isAuthenticated && (
            <Route
              path="/"
              element={<Navigate to={lastVisitedPath} replace />}
            />
          )}
          {/* <Route 
             path="/nms-dash/*"
             element={
               <HomePageNMSDash 
                 themeMode={themeMode} 
                 toggleTheme={toggleTheme}
               />
             }
          /> */}
        </Route>
        {!isAuthenticated && <Route path="/" element={<Login />} />}
      </Routes>
    </Router>
  );
};

export default AppRoutes;
